<template>
  <div
    v-if="visible"
    class="dialog-container dialog-primary error-dialog-primary"
    ref="containerRef">
    <div class="mask" />
    <div
      class="dialog-box dialog-primary"
      ref="dialogRef"
      :style="`width:${width ? `${width}px` : '600px'}`">
      <div
        class="dialog-header dialog-primary-header"
        @mousedown="handleDragStart">
        <span class="dialog-primary-header-icon">
          <i
            v-if="icon"
            :fontSize="size"
            class="el-icon el-icon-warning"></i>
          <span
            class="text-overflow"
            :title="title"
            >{{ title }}</span
          >
        </span>
        <span
          class="icon"
          @click="closeDialog">
          <i class="el-icon-close" />
        </span>
      </div>
      <div class="dialog-content dialog-primary-body"><slot></slot></div>
      <div
        class="dialog-footer"
        v-if="footerBtn.length">
        <el-button
          v-if="footerBtn.includes('cancel')"
          size="small"
          plain
          class="normal-ang-btn gr8 hollowOut-btn"
          @click="closeDialog">
          取消
        </el-button>
        <el-button
          v-if="footerBtn.includes('submit')"
          size="small"
          plain
          class="primary-btn primary-ang-btn sumbit-btn"
          @click="ok">
          确定
        </el-button>
      </div>
      <div
        v-if="isResize"
        class="drag-resize"
        @mousedown="handleResizeStart">
        <icon-svg
          icon-class="ic-zhankaisuofang"
          class="icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDragEnable: false,
      isResizeEnable: false
    }
  },
  props: {
    title: String,
    visible: Boolean,
    isResize: Boolean,
    footerBtn: Array,
    width: Number,
    submit: Function,
    cancel: Function,
    size: [Number, String],
    icon: {
      //  eslint-disable-next-line
      type: [String, Boolean, Number],
      default: false
    }
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          let containerRef = this.$refs.containerRef
          document.body.appendChild(containerRef)
        })

        document.addEventListener('keydown', this.onEnterDown)
      } else {
        document.removeEventListener('keydown', this.onEnterDown)
      }
    }
  },
  beforeDestroy() {
    if (this.$refs.containerRef) {
      document.body.contains(this.$refs.containerRef) &&
        document.body.removeChild(this.$refs.containerRef)
    }
  },
  methods: {
    handleDragStart(e) {
      e.target.style.cursor = 'move'

      this.isDragEnable = true
      this.originTop = e.target.offsetParent.offsetTop
      this.originLeft = e.target.offsetParent.offsetLeft
      this.originX = e.clientX
      this.originY = e.clientY

      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('mouseup', this.onMouseUp)
    },
    onEnterDown(event) {
      // 防止正常输入框过滤触发事件
      let form = event.srcElement.form
      if (!form) return

      if (event.keyCode === 13) {
        if (this.submit) {
          this.submit()
        }
      }
    },
    closeDialog(e) {
      e.preventDefault()
      if (this.cancel) {
        this.cancel()
      }
    },
    ok(e) {
      e.preventDefault()
      if (this.submit) {
        this.submit()
      }
    },
    onMouseMove(event) {
      const dialogRef = this.$refs.dialogRef

      if (this.isDragEnable) {
        let deltaX = event.clientX - this.originX
        let deltaY = event.clientY - this.originY
        let activeElement = document.activeElement
        let maxLeft = activeElement.offsetWidth - dialogRef.offsetWidth
        let maxTop = activeElement.offsetHeight - dialogRef.offsetHeight
        let top = deltaY + this.originTop
        let left = deltaX + this.originLeft
        if (left > maxLeft) return false
        if (top > maxTop) return false
        if (top <= 0) return false
        if (left <= 0) return false

        dialogRef.style.top = top + 'px'
        dialogRef.style.left = left + 'px'
      }

      if (this.isResizeEnable) {
        dialogRef.style.left = dialogRef.offsetLeft + 'px'

        const minWidth = 200
        const minHeight = 150

        let mouseX = event.clientX
        let mouseY = event.clientY
        let boxX = dialogRef.getBoundingClientRect().left
        let boxY = dialogRef.getBoundingClientRect().top

        let newWidth = mouseX - boxX + 6
        let newHeight = mouseY - boxY + 6
        newWidth = newWidth > minWidth ? newWidth : minWidth
        newHeight = newHeight > minHeight ? newHeight : minHeight

        dialogRef.style.width = newWidth + 'px'
        dialogRef.style.height = newHeight + 'px'
      }
    },
    handleResizeStart(e) {
      this.isResizeEnable = true
      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('mouseup', this.onMouseUp)
    },
    onMouseUp(e) {
      this.isDragEnable = false
      this.isResizeEnable = false
      document.removeEventListener('mousemove', this.onMouseMove)
      document.removeEventListener('mouseup', this.onMouseUp)
      e.target.style.cursor = 'default'
    },
    getWidth(parentRef, childRef) {
      let width
      parentRef.style.cssText = `display:block;`
      width = childRef.offsetWidth
      // parentRef.style.cssText = "display:none;";
      return width
    },
    getHeight(parentRef, childRef) {
      let height
      parentRef.style.cssText = `display:block;`
      height = childRef.offsetHeight
      // parentRef.style.cssText = "display:none;";
      return height
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.dialog-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--dialog-mask-bgColor);
  }

  .dialog-box {
    z-index: 9999;
    border-radius: 16px;
    border: 1px solid var(--dialog-border-color);

    .dialog-header {
      color: var(--default-color);
      border-radius: 8px 8px 0px 0px;
      .dialog-primary-header-icon {
        max-width: 90%;

        .text-overflow {
          width: 100%;
        }
      }
      .icon {
        display: flex;
        color: var(--dialog-header-icon-color);
        cursor: pointer;
        padding: 5px; 
        border-radius: 4px;
      }
    }

    .dialog-footer {
      width: 100%;
      text-align: right;
      display: flex;
      justify-content: flex-end;

      .el-button {
        margin-left: 0;
      }

      .positive {
        color: var(--primary-font-color);
        background: var(--primary-color);
        border-color: var(--primary-color);
      }

      .sumbit-btn {
        &:hover {
          background: var(--base-bg-light-color40);
        }
      }
    }

    .drag-resize {
      position: absolute;
      width: 8px;
      height: 8px;
      bottom: 11px;
      right: 10px;
      cursor: nw-resize;
    }
  }
}
</style>
